export default __webpack_public_path__ + "226351a063913066e5209784c4f48745.png";